import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import rootReducer from "../Reducers"; // Your combined reducers

const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_ENCRYPT_SECRET_KEY,
  onError: (error) => {
    console.error("Encryption Error:", error);
    localStorage.clear();
    storage.removeItem("persist:root");
    window.location.href = "/login";
  },
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Only persist auth slice
  transforms: [encryptor],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false, // disable this one
      serializableCheck: false, // optionally disable this too if needed
    }), // DO NOT add thunk again — it's already included
});

export const persistor = persistStore(store, null, () => {
  storage.removeItem("persist:root");
});
